(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
    (function(){
      var d = document,
      accordionToggles = d.querySelectorAll('.js-accordionTrigger'),
      setAria,
      setAccordionAria,
      switchAccordion,
      touchSupported = ('ontouchstart' in window),
      pointerSupported = ('pointerdown' in window);
  
      skipClickDelay = function(e){
        e.preventDefault();
        e.target.click();
      }
  
        setAriaAttr = function(el, ariaType, newProperty){
        el.setAttribute(ariaType, newProperty);
      };
      setAccordionAria = function(el1, el2, expanded){
        switch(expanded) {
          case "true":
            setAriaAttr(el1, 'aria-expanded', 'true');
            setAriaAttr(el2, 'aria-hidden', 'false');
            break;
          case "false":
            setAriaAttr(el1, 'aria-expanded', 'false');
            setAriaAttr(el2, 'aria-hidden', 'true');
            break;
          default:
            break;
        }
      };
  
      // switchAccordion = function(e) {
      //   e.preventDefault();
      //   var thisAnswer = e.target.parentNode.nextElementSibling;
      //   var thisQuestion = e.target;
      //   if(thisAnswer.classList.contains('is-collapsed')) {
      //     setAccordionAria(thisQuestion, thisAnswer, 'true');
      //   } else {
      //     setAccordionAria(thisQuestion, thisAnswer, 'false');
      //   }
      //   thisQuestion.classList.toggle('is-collapsed');
      //   thisQuestion.classList.toggle('is-expanded');
      //   thisAnswer.classList.toggle('is-collapsed');
      //   thisAnswer.classList.toggle('is-expanded');
  
      //   thisAnswer.classList.toggle('animateIn');
      // };
      for (var i=0,len=accordionToggles.length; i<len; i++) {
        if(touchSupported) {
          accordionToggles[i].addEventListener('touchstart', skipClickDelay, false);
        }
        if(pointerSupported){
          accordionToggles[i].addEventListener('pointerdown', skipClickDelay, false);
        }
        accordionToggles[i].addEventListener('click', switchAccordion, false);
      }
    })();

    $(document).ready(function(){
            $(".accordion-titel").click(function(){
            
            $(this).find('.accordion-title').toggleClass('is-collapsed')
            $(this).parent(".accordion-item").find(".accordion-contant").slideToggle();
            $(this).parent(".accordion-item").prevAll(".accordion-item").find(".accordion-contant").slideUp();
            $(this).parent(".accordion-item").prevAll(".accordion-item").find(".accordion-title").removeClass('is-collapsed')
            $(this).parent(".accordion-item").nextAll(".accordion-item").find(".accordion-contant").slideUp();
            $(this).parent(".accordion-item").nextAll(".accordion-item").find(".accordion-title").removeClass('is-collapsed')
            });
        });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-template"]) return;
  try {
    
  function review_check(num) {
    var j = parseInt(num);
    if($('.spr-reviews .spr-review').length > 0) {
      $('i').changeElementType('em');
    } else {
      if(j < 20) {
        j = num + 1;
        setTimeout(function(){review_check(j)}, 1000);
      }
    }
  }
  $(document).ready(function(){
    review_check(1);
    $('.products-related').slick({
      infinite: false,
      arrows: false,
      dots: true,
      fade: true,
      customPaging : function(slider, i) {
        var tabtype = $(slider.$slides[i]).data('tabtype');
        return '<a class="btn btn--secondary">'+tabtype+'</a>';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-skylight-template"]) return;
  try {
    
  function review_check(num) {
    var j = parseInt(num);
    if($('.spr-reviews .spr-review').length > 0) {
      $('i').changeElementType('em');
    } else {
      if(j < 20) {
        j = num + 1;
        setTimeout(function(){review_check(j)}, 1000);
      }
    }
  }
  $(document).ready(function(){
    review_check(1);
    $('.products-related').slick({
      infinite: false,
      arrows: false,
      dots: true,
      fade: true,
      customPaging : function(slider, i) {
        var tabtype = $(slider.$slides[i]).data('tabtype');
        return '<a class="btn btn--secondary">'+tabtype+'</a>';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  function review_check(num) {
    var j = parseInt(num);
    if($('.spr-reviews .spr-review').length > 0) {
      $('i').changeElementType('em');
    } else {
      if(j < 20) {
        j = num + 1;
        setTimeout(function(){review_check(j)}, 1000);
      }
    }
  }
  $(document).ready(function(){
    review_check(1);
    $('.products-related').slick({
      infinite: false,
      arrows: false,
      dots: true,
      fade: true,
      customPaging : function(slider, i) {
        var tabtype = $(slider.$slides[i]).data('tabtype');
        return '<a class="btn btn--secondary">'+tabtype+'</a>';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-yeti-template"]) return;
  try {
    
      function review_check(num) {
        var j = parseInt(num);
        if($('.spr-reviews .spr-review').length > 0) {
          $('i').changeElementType('em');
        } else {
          if(j < 20) {
            j = num + 1;
            setTimeout(function(){review_check(j)}, 1000);
          }
        }
      }
      $(document).ready(function(){
        review_check(1);
        $('.products-related').slick({
          infinite: false,
          arrows: false,
          dots: true,
          fade: true,
          customPaging : function(slider, i) {
            var tabtype = $(slider.$slides[i]).data('tabtype');
            return '<a class="btn btn--secondary">'+tabtype+'</a>';
          }
        });
      });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yeti-pro-template"]) return;
  try {
    
  function review_check(num) {
    var j = parseInt(num);
    if($('.spr-reviews .spr-review').length > 0) {
      $('i').changeElementType('em');
    } else {
      if(j < 20) {
        j = num + 1;
        setTimeout(function(){review_check(j)}, 1000);
      }
    }
  }
  $(document).ready(function(){
    review_check(1);
    $('.products-related').slick({
      infinite: false,
      arrows: false,
      dots: true,
      fade: true,
      customPaging : function(slider, i) {
        var tabtype = $(slider.$slides[i]).data('tabtype');
        return '<a class="btn btn--secondary">'+tabtype+'</a>';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
